<template>
  <div class="about-page-see-more-button">
    <ButtonSecondary
      :text="text"
      @click-secondary-button="onClickSecondaryButton"
    />
  </div>
</template>
<script setup>
import ButtonSecondary from './ButtonSecondary.vue'

const props = defineProps({
  text: {
    type: String,
    required: false,
    default: 'もっと見る'
  },
  href: {
    type: String,
    required: true
  }
})

const onClickSecondaryButton = () => {
  window.location.href = props.href
}
</script>
<style lang="scss" scoped>
.about-page-see-more-button {
  display: flex;
  justify-content: center;
  width: 100%;

  @media all and (max-width: ($base-contents-width - 1)) {
    width: auto;
  }

  > button {
    width: 100%;
    max-width: 384px;
  }
}
</style>
